import React from 'react';
import PropTypes from 'prop-types';

import { Container, Form, Icon, Button, Message, Header, Checkbox} from 'semantic-ui-react';

const UserRegistration = props => {
    let errorMessage;
    if (props.error) {
        const content = Array.isArray(props.error) ? props.error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : props.error;
        errorMessage = (<Message error header="Verification Failed" content={content} />);
    }
    const {password, confirmPassword, agreeTerms} = props.data;
    const passwordsMatch = (password && confirmPassword && password === confirmPassword) || false;
    return (
        <Container>
            <Form onSubmit={props.onSubmit} loading={props.loading} error>
                <Header as="h1" textAlign="center" content="Account Registration" />
                {errorMessage}
                <Form.Field inline>
                    <Icon name="user" size="big" />
                    <input name="username" placeholder="Email Address (Username)" onChange={props.onChange} type="email" />
                </Form.Field>
                <Form.Field inline>
                    <Icon name="lock" size="big" />
                    <input name="password" type="password" placeholder="Password" onChange={props.onChange} />
                </Form.Field>
                <Form.Field inline>
                    <Icon name="lock" size="big" />
                    <input name="confirmPassword" type="password" placeholder="Confirm Password" onChange={props.onChange} />
                </Form.Field>
                <Form.Field inline>
                    <Icon size="big" />
                    <div style={{paddingLeft: 5}}>
                    <Header as="h4" content="Password Requirements:"/>
                    <ul>
                        <li><Header as="h4" content="Must be at least 8 characters"/></li>
                        <li><Header as="h4" content="Must contain at least one digit"/></li>
                        <li><Header as="h4" content="Must contain at least one uppercase and one lowercase character"/></li>
                    </ul>
                    </div>
                </Form.Field>
                <Form.Field className="centered">
                    <Button content="Show Terms" type="button" onClick={props.onShowTerms} />                    
                </Form.Field>
                <Form.Field className="centered">
                    <Checkbox name="agreeTerms" label="I have read and accept the above terms" onChange={props.onChange} />
                </Form.Field>
                <Button basic fluid type="submit" disabled={!(passwordsMatch && agreeTerms)}>CREATE ACCOUNT</Button>
            </Form>
        </Container>
    );
};

UserRegistration.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.object.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ]),
    onShowTerms: PropTypes.func.isRequired,
};

export default UserRegistration;